import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-537305de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "fs-3 text-center mt-9" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Direct Rebate Setting ( 直接反佣設置 )", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Level Rebate Setting ( 層級反佣設置 )", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "typeBadge" }
const _hoisted_13 = { class: "typeBadge ms-5" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "typeBadge" }, "No Pips / Commission Setting", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "d-flex justify-content-end align-items center" }
const _hoisted_18 = { class: "mt-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "me-9",
  for: "directRebate"
}, "Direct Rebate", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "me-9",
  for: "allocationRebate"
}, "Allocation Rebate", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "me-9",
  for: "levelSet"
}, "Level Set", -1))
const _hoisted_22 = {
  key: 1,
  class: "mt-9"
}
const _hoisted_23 = { class: "fs-3 mb-3 d-flex justify-content-center align-items-center" }
const _hoisted_24 = { class: "accountBadge d-flex justify-content-center align-items-center ms-3 me-3" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  class: "px-0 d-flex gap-1",
  style: {"border-bottom":"3px #ffd400 solid"}
}

import { ref, onMounted } from "vue";
import { AccountRoleTypes } from "@/core/types/AccountInfos";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import RebateService from "../../rebate/services/RebateService";
import { RebateDistributionTypes } from "@/core/types/RebateDistributionTypes";
import AccountRebateInfo from "./AccountRebateInfo.vue";
import AccountRebateDirect from "./AccountRebateDirect.vue";
import AccountRebateLevel from "./AccountRebateLevel.vue";
import AccountRebateRelation from "./AccountRebateRelation.vue";
import { Field } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRebate',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;

const isLoading = ref(true);
const updatingType = ref(false);
const accountDetails = ref({} as any);
const pcSettings = ref({} as any);
const isClient = ref(false);


const rebateType = ref();
const activeTab = ref();

onMounted(async () => {
  accountDetails.value = props.accountDetails;

  isClient.value = accountDetails.value.role === AccountRoleTypes.Client;

  if (isClient.value) {
    rebateType.value =
      accountDetails.value.rebateClientRule.distributionType.toString();

    activeTab.value = accountDetails.value.rebateClientRule.distributionType;

    pcSettings.value = JSON.parse(
      accountDetails.value.rebateClientRule?.schema
    );

    if (Object.keys(pcSettings.value).length != 0) {
      pcSettings.value = pcSettings.value.find(function (item) {
        return item.accountType === accountDetails.value.type;
      });
    } else {
      pcSettings.value = {};
    }
  } else {
    activeTab.value = "relationSheet";
  }
  // await fetchData();
  isLoading.value = false;
});

// const fetchData = async () => {
//   if (accountDetails.value.role === AccountRoleTypes.Client) {
//     if (isDirect(accountDetails.value.rebateClientRule.distributionType)) {
//       // 直接返佣，获取返佣规则
//       // await fetchDirectRebateData();
//     } else {
//       // Client层级返佣，获取上级账号信息
//       await fetchLevelRebateData();
//     }
//   } else {
//     // IB层级返佣，获取上级账号信息
//     await fetchLevelRebateData();
//   }
// };

// const fetchDirectRebateData = async () => {
//   const responseBody = await RebateService.getRebateDirectRule(
//     rebateRuleCriteria
//   );
//   rebateRuleCriteria.value = responseBody.criteria;
//   rebateRuleData.value = responseBody.data;

//   console.log("direct", responseBody);
// };

// const fetchLevelRebateData = async () => {
//   // // 如果是Client获取返佣配置
//   // if (accountDetails.value.role === AccountRoleTypes.Client) {
//   //   const _clientSchema = await RebateService.getRebateClientRule(
//   //     accountDetails.value.rebateClientRule.id
//   //   );
//   //   clientSchema.value = _clientSchema;
//   // }
// };

const updateDistributionType = async () => {
  updatingType.value = true;

  try {
    await RebateService.putRebateAllocationRule(
      props.accountDetails.rebateClientRule.id,
      { distributionType: rebateType.value }
    );
    accountDetails.value.rebateClientRule.distributionType = rebateType.value;
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    updatingType.value = false;
    activeTab.value = rebateType.value;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoadingRing)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(AccountRebateInfo, { "account-details": accountDetails.value }, null, 8, ["account-details"]),
        _hoisted_3,
        (isClient.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (rebateType.value == _unref(RebateDistributionTypes).Direct)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                  : _createCommentVNode("", true),
                (rebateType.value == _unref(RebateDistributionTypes).Allocation)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      (Object.keys(pcSettings.value).length != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, "Pips: " + _toDisplayString(pcSettings.value.pips), 1),
                            _createElementVNode("span", _hoisted_13, "Commission: " + _toDisplayString(pcSettings.value.commission), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(Field), {
                    modelValue: rebateType.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rebateType).value = $event)),
                    class: "form-check-input widget-9-check me-3",
                    type: "radio",
                    name: "directRebate",
                    value: "1",
                    onChange: updateDistributionType
                  }, null, 8, ["modelValue"]),
                  _hoisted_19,
                  _createVNode(_unref(Field), {
                    modelValue: rebateType.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rebateType).value = $event)),
                    class: "form-check-input widget-9-check me-3",
                    type: "radio",
                    name: "allocationRebate",
                    value: "2",
                    onChange: updateDistributionType
                  }, null, 8, ["modelValue"]),
                  _hoisted_20,
                  _createVNode(_unref(Field), {
                    modelValue: rebateType.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((rebateType).value = $event)),
                    class: "form-check-input widget-9-check me-3",
                    type: "radio",
                    name: "levelSet",
                    value: "3",
                    onChange: updateDistributionType
                  }, null, 8, ["modelValue"]),
                  _hoisted_21
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createTextVNode(" This is a "),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("type.accountRole." + accountDetails.value.role)), 1),
                _createTextVNode(" Account ")
              ])
            ])),
        (updatingType.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_LoadingRing)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                (rebateType.value == _unref(RebateDistributionTypes).Direct && isClient.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["basic-tab", { 'active-tab': activeTab.value == _unref(RebateDistributionTypes).Direct }]),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (activeTab.value = rebateType.value))
                    }, " Direct Rebate ", 2))
                  : _createCommentVNode("", true),
                (rebateType.value == _unref(RebateDistributionTypes).Allocation && isClient.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass(["basic-tab", {
            'active-tab': activeTab.value == _unref(RebateDistributionTypes).Allocation,
          }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (activeTab.value = rebateType.value))
                    }, " Allocation Rebate ", 2))
                  : _createCommentVNode("", true),
                (rebateType.value == _unref(RebateDistributionTypes).LevelSet && isClient.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: _normalizeClass(["basic-tab", {
            'active-tab': activeTab.value == _unref(RebateDistributionTypes).LevelSet,
          }]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (activeTab.value = rebateType.value))
                    }, " Level Set Rebate ", 2))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(["basic-tab", { 'active-tab': activeTab.value === 'relationSheet' }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (activeTab.value = 'relationSheet'))
                }, " Relation Sheet ", 2)
              ]),
              (activeTab.value == _unref(RebateDistributionTypes).Direct && isClient.value)
                ? (_openBlock(), _createBlock(AccountRebateDirect, {
                    key: 0,
                    "account-details": accountDetails.value
                  }, null, 8, ["account-details"]))
                : _createCommentVNode("", true),
              (activeTab.value == _unref(RebateDistributionTypes).Allocation && isClient.value)
                ? (_openBlock(), _createBlock(AccountRebateLevel, {
                    key: 1,
                    "account-details": accountDetails.value
                  }, null, 8, ["account-details"]))
                : _createCommentVNode("", true),
              (activeTab.value == _unref(RebateDistributionTypes).LevelSet && isClient.value)
                ? (_openBlock(), _createBlock(AccountRebateLevel, {
                    key: 2,
                    "account-details": accountDetails.value
                  }, null, 8, ["account-details"]))
                : _createCommentVNode("", true),
              (activeTab.value == 'relationSheet')
                ? (_openBlock(), _createBlock(AccountRebateRelation, {
                    key: 3,
                    accountId: accountDetails.value.id
                  }, null, 8, ["accountId"]))
                : _createCommentVNode("", true)
            ]))
      ]))
}
}

})